// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.navbar {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  padding: 1rem 2rem;
  color: #333;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 70px;
  height: 120px;
  display: flex;
  align-items: center;
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.navbar-left {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  flex-shrink: 0;
}

.logo {
  max-width: 100px;
  height: auto;
  margin-right: 0.75rem;
  z-index: 1000;
}

.company-name {
  font-size: 2rem !important; 
  font-weight: 500 !important;
  background: linear-gradient(90deg, #5f17ad, #2575fc);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-family: "Raleway", sans-serif;
  letter-spacing: 1px;
  white-space: nowrap;
  overflow: visible;
  flex-shrink: 0;
  text-align: center;
  margin-top: 20px;
  margin-left: -20px;
}

.navbar-middle {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  position: relative;
  z-index: 1001;
}

.navbar-middle a,
.navbar-middle .policy-link {
  color: rgb(85, 85, 85);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 500;
  padding: 0.5rem 0.75rem;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.navbar-middle a::after,
.navbar-middle .policy-link::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background: linear-gradient(90deg, #5f17ad, #2575fc);
  transition: width 0.3s ease;
}

.navbar-middle a:hover::after,
.navbar-middle .policy-link:hover::after {
  width: 100%;
}

.navbar-middle .login-button {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  border-radius: 25px;
  background: linear-gradient(135deg, #36036a, #2575fc);
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}

.navbar-middle .login-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

.caret-down {
  font-size: 2rem;
  color: #333;
  margin-left: 0.0rem;
  margin-top: -9px;
  transform: rotate(180deg);
  display: inline-block;
}

.icon {
  font-size: 1.2rem;
}

.mobile-menu-icon {
  display: none;
  cursor: pointer;
  font-size: 1.5rem;
}

.mobile-menu-icon .icon {
  font-size: 1.5rem;
}

/* Refund Policy Container */
.policy-link-container {
  position: relative;
  display: inline-block;
}

.policy-link {
  position: relative;
}

/* Refund Policy Dropdown Styles */
.policy-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1002;
  width: auto;
  min-width: 250px;
}

.policy-dropdown-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  max-height: 350px;
  overflow-y: auto;
  width: 250px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none; 
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.policy-dropdown-content.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.policy-dropdown-content.show {
  pointer-events: auto;
}




/* Mobile: Click-based dropdown */
@media (max-width: 1024px) {
  .policy-dropdown {
    position: static;
    width: 100%;
    left: 0;
  }
  
  .policy-dropdown-content {
    position: static;
    width: 100%;
    margin-top: 0.5rem;
    max-height: 0;
    padding: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    box-shadow: none;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.95);
    border: none;
    opacity: 1;
    visibility: visible;
    transform: none;
  }
  
  .policy-dropdown-content.show {
    max-height: 350px;
    padding: 1rem;
    opacity: 1;
    visibility: visible;
  }
  
  /* Override hover effects for mobile */
  .policy-link:hover .policy-dropdown-content:not(.show) {
    opacity: 0;
    visibility: hidden;
    transform: none;
  }
}

.policy-dropdown-content a {
  color: #2c3e50;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
}

.policy-dropdown-content a:hover {
  background: linear-gradient(90deg, rgba(95, 23, 173, 0.1), rgba(37, 117, 252, 0.1));
  color: #5f17ad;
  padding-left: 1.25rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .navbar {
    padding: 0.625rem 1rem;
    height: auto;
    min-height: 70px;
  }

  .logo {
    max-width: 70px;
  }

  .company-name {
    font-size: 1.8rem;
    font-weight: 700;
    margin-top: 15px;
    margin-left: -15px;
  }

  .navbar-middle {
    display: none;
    flex-direction: column;
    gap: 0.625rem;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    padding: 1rem;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    z-index: 1001;
    width: 100%;
    align-items: flex-start;
  }

  .navbar-middle.active {
    display: flex;
  }

  .mobile-menu-icon {
    display: block;
  }

  .navbar-middle a,
  .navbar-middle .policy-link {
    width: 100%;
    padding: 0.75rem 0;
    font-size: 1.1rem;
  }

  .navbar-middle .login-button {
    padding: 0.75rem 1.5rem;
    margin-top: 0.5rem;
    align-self: center;
    width: auto;
  }

  .policy-link-container {
    width: 100%;
  }
  
  .policy-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

@media (max-width: 768px) {
  .logo {
    max-width: 60px;
  }

  .company-name {
    font-size: 1.5rem;
    font-weight: 700;
    margin-top: 10px;
    margin-left: -10px;
  }
  
  .navbar {
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 480px) {
  .logo {
    max-width: 50px;
  }

  .company-name {
    font-size: 1.2rem;
    font-weight: 700;
    margin-left: 0.5rem;
    margin-top: 5px;
  }
  
  .navbar-middle {
    padding: 0.75rem;
  }
  
  .navbar-middle a,
  .navbar-middle .policy-link {
    font-size: 1rem;
    padding: 0.625rem 0;
  }
}

@media (min-width: 1025px) and (max-width: 1440px) {
  .navbar {
    padding: 1.25rem 1.875rem;
  }

  .navbar-middle {
    gap: 1.25rem;
  }

  .navbar-middle .login-button {
    padding: 0.625rem 1.25rem;
  }
}

@media (min-width: 1441px) {
  .navbar {
    padding: 1.25rem 2.5rem;
  }

  .navbar-middle {
    gap: 1.5625rem;
  }

  .navbar-middle .login-button {
    padding: 0.75rem 1.5rem;
  }
  
  .policy-dropdown-content {
    width: 280px;
  }
}

/* Active link styles */
.navbar-middle a.active {
  color: #5f17ad;
  font-weight: 600;
}

.navbar-middle a.active::after {
  width: 100%;
}

/* Smooth transitions for all interactive elements */
.navbar-middle a,
.navbar-middle .policy-link,
.policy-dropdown-content a,
.navbar-middle .login-button {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Prevent text selection on interactive elements */
.policy-link,
.mobile-menu-icon {
  -webkit-user-select: none;
          user-select: none;
}

/* Dropdown arrow animation */
.policy-link .caret-down {
  transition: transform 0.3s ease;
}


/* Ensure dropdown stays above other elements */
.policy-dropdown-content {
  z-index: 1003;
}

/* Fix for dropdown positioning in navbar-middle */
.navbar-middle .policy-link-container {
  height: auto;              /* IMPORTANT */
  display: inline-flex;      /* tight wrap */
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oDAAoD;EACpD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,wEAAwE;EACxE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;;;;;AAKA,iCAAiC;AACjC;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,OAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,mDAAmD;IACnD,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,UAAU;IACV,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,UAAU;IACV,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mFAAmF;EACnF,cAAc;EACd,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;IACb,4BAA4B;IAC5B,yCAAyC;IACzC,aAAa;IACb,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,oDAAoD;AACpD;;;;EAIE,iDAAiD;AACnD;;AAEA,mDAAmD;AACnD;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,+BAA+B;AACjC;;;AAGA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,YAAY,eAAe,cAAc;EACzC,oBAAoB,OAAO,eAAe;EAC1C,mBAAmB;AACrB","sourcesContent":["/* Base Styles */\n.navbar {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  padding: 1rem 2rem;\n  color: #333;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  min-height: 70px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n}\n\n.navbar-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.navbar-left {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.logo {\n  max-width: 100px;\n  height: auto;\n  margin-right: 0.75rem;\n  z-index: 1000;\n}\n\n.company-name {\n  font-size: 2rem !important; \n  font-weight: 500 !important;\n  background: linear-gradient(90deg, #5f17ad, #2575fc);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-family: \"Raleway\", sans-serif;\n  letter-spacing: 1px;\n  white-space: nowrap;\n  overflow: visible;\n  flex-shrink: 0;\n  text-align: center;\n  margin-top: 20px;\n  margin-left: -20px;\n}\n\n.navbar-middle {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n  justify-content: flex-end;\n  flex-grow: 1;\n  position: relative;\n  z-index: 1001;\n}\n\n.navbar-middle a,\n.navbar-middle .policy-link {\n  color: rgb(85, 85, 85);\n  text-decoration: none;\n  font-size: 1.1rem;\n  font-weight: 500;\n  padding: 0.5rem 0.75rem;\n  position: relative;\n  cursor: pointer;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.navbar-middle a::after,\n.navbar-middle .policy-link::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #5f17ad, #2575fc);\n  transition: width 0.3s ease;\n}\n\n.navbar-middle a:hover::after,\n.navbar-middle .policy-link:hover::after {\n  width: 100%;\n}\n\n.navbar-middle .login-button {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  border-radius: 25px;\n  background: linear-gradient(135deg, #36036a, #2575fc);\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  white-space: nowrap;\n}\n\n.navbar-middle .login-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n}\n\n.caret-down {\n  font-size: 2rem;\n  color: #333;\n  margin-left: 0.0rem;\n  margin-top: -9px;\n  transform: rotate(180deg);\n  display: inline-block;\n}\n\n.icon {\n  font-size: 1.2rem;\n}\n\n.mobile-menu-icon {\n  display: none;\n  cursor: pointer;\n  font-size: 1.5rem;\n}\n\n.mobile-menu-icon .icon {\n  font-size: 1.5rem;\n}\n\n/* Refund Policy Container */\n.policy-link-container {\n  position: relative;\n  display: inline-block;\n}\n\n.policy-link {\n  position: relative;\n}\n\n/* Refund Policy Dropdown Styles */\n.policy-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1002;\n  width: auto;\n  min-width: 250px;\n}\n\n.policy-dropdown-content {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n  max-height: 350px;\n  overflow-y: auto;\n  width: 250px;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none; \n  transform: translateY(-10px);\n  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.policy-dropdown-content.show {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.policy-dropdown-content.show {\n  pointer-events: auto;\n}\n\n\n\n\n/* Mobile: Click-based dropdown */\n@media (max-width: 1024px) {\n  .policy-dropdown {\n    position: static;\n    width: 100%;\n    left: 0;\n  }\n  \n  .policy-dropdown-content {\n    position: static;\n    width: 100%;\n    margin-top: 0.5rem;\n    max-height: 0;\n    padding: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease, padding 0.3s ease;\n    box-shadow: none;\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.95);\n    border: none;\n    opacity: 1;\n    visibility: visible;\n    transform: none;\n  }\n  \n  .policy-dropdown-content.show {\n    max-height: 350px;\n    padding: 1rem;\n    opacity: 1;\n    visibility: visible;\n  }\n  \n  /* Override hover effects for mobile */\n  .policy-link:hover .policy-dropdown-content:not(.show) {\n    opacity: 0;\n    visibility: hidden;\n    transform: none;\n  }\n}\n\n.policy-dropdown-content a {\n  color: #2c3e50;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  display: block;\n  width: 100%;\n  text-align: left;\n  border: none;\n  background: transparent;\n}\n\n.policy-dropdown-content a:hover {\n  background: linear-gradient(90deg, rgba(95, 23, 173, 0.1), rgba(37, 117, 252, 0.1));\n  color: #5f17ad;\n  padding-left: 1.25rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .navbar {\n    padding: 0.625rem 1rem;\n    height: auto;\n    min-height: 70px;\n  }\n\n  .logo {\n    max-width: 70px;\n  }\n\n  .company-name {\n    font-size: 1.8rem;\n    font-weight: 700;\n    margin-top: 15px;\n    margin-left: -15px;\n  }\n\n  .navbar-middle {\n    display: none;\n    flex-direction: column;\n    gap: 0.625rem;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: rgba(255, 255, 255, 0.98);\n    backdrop-filter: blur(10px);\n    padding: 1rem;\n    border-radius: 0 0 10px 10px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n    z-index: 1001;\n    width: 100%;\n    align-items: flex-start;\n  }\n\n  .navbar-middle.active {\n    display: flex;\n  }\n\n  .mobile-menu-icon {\n    display: block;\n  }\n\n  .navbar-middle a,\n  .navbar-middle .policy-link {\n    width: 100%;\n    padding: 0.75rem 0;\n    font-size: 1.1rem;\n  }\n\n  .navbar-middle .login-button {\n    padding: 0.75rem 1.5rem;\n    margin-top: 0.5rem;\n    align-self: center;\n    width: auto;\n  }\n\n  .policy-link-container {\n    width: 100%;\n  }\n  \n  .policy-link {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .logo {\n    max-width: 60px;\n  }\n\n  .company-name {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin-top: 10px;\n    margin-left: -10px;\n  }\n  \n  .navbar {\n    padding: 0.5rem 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo {\n    max-width: 50px;\n  }\n\n  .company-name {\n    font-size: 1.2rem;\n    font-weight: 700;\n    margin-left: 0.5rem;\n    margin-top: 5px;\n  }\n  \n  .navbar-middle {\n    padding: 0.75rem;\n  }\n  \n  .navbar-middle a,\n  .navbar-middle .policy-link {\n    font-size: 1rem;\n    padding: 0.625rem 0;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .navbar {\n    padding: 1.25rem 1.875rem;\n  }\n\n  .navbar-middle {\n    gap: 1.25rem;\n  }\n\n  .navbar-middle .login-button {\n    padding: 0.625rem 1.25rem;\n  }\n}\n\n@media (min-width: 1441px) {\n  .navbar {\n    padding: 1.25rem 2.5rem;\n  }\n\n  .navbar-middle {\n    gap: 1.5625rem;\n  }\n\n  .navbar-middle .login-button {\n    padding: 0.75rem 1.5rem;\n  }\n  \n  .policy-dropdown-content {\n    width: 280px;\n  }\n}\n\n/* Active link styles */\n.navbar-middle a.active {\n  color: #5f17ad;\n  font-weight: 600;\n}\n\n.navbar-middle a.active::after {\n  width: 100%;\n}\n\n/* Smooth transitions for all interactive elements */\n.navbar-middle a,\n.navbar-middle .policy-link,\n.policy-dropdown-content a,\n.navbar-middle .login-button {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Prevent text selection on interactive elements */\n.policy-link,\n.mobile-menu-icon {\n  user-select: none;\n}\n\n/* Dropdown arrow animation */\n.policy-link .caret-down {\n  transition: transform 0.3s ease;\n}\n\n\n/* Ensure dropdown stays above other elements */\n.policy-dropdown-content {\n  z-index: 1003;\n}\n\n/* Fix for dropdown positioning in navbar-middle */\n.navbar-middle .policy-link-container {\n  height: auto;              /* IMPORTANT */\n  display: inline-flex;      /* tight wrap */\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
